import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpHandlerArgModel } from "@core/data/http.service";
import { BaseMoghimProxyService, MoghimApiProxyResult } from "@core/data/BaseMoghimProxyService";
import { Observable } from "rxjs";

@Injectable()
export class MoghimAccountingProxy extends BaseMoghimProxyService {

    constructor(http: HttpClient, baseSettings?: HttpHandlerArgModel) {
        super(http, 'MoghimAccounting', baseSettings);
    }

    public GetFinancialYearList() : Observable<MoghimApiProxyResult<TAccounting.FinancialYear>>
    {
        return this.Post<TAccounting.FinancialYear>({
            endPointId : 'financialyear-list'
        });
    }

    public GetVendorList() : Observable<MoghimApiProxyResult<TAccounting.Vendor>>
    {
        return this.Post<TAccounting.Vendor>({
            endPointId : 'get-all-vendor-systems'
        });
    }

    public GetMappedCodes(input : TAccounting.GetMappedCodesInputModel) : Observable<MoghimApiProxyResult<TAccounting.GetMappedCodes>>
    {
        return this.Post<TAccounting.GetMappedCodes>({
            model : input,
            endPointId : 'get-mapped-codes'
        });
    }

    public GetAccountingCodes(input: TAgencyAccounting.GetAccountingCodesInputModel): Observable<MoghimApiProxyResult<TAgencyAccounting.GetAccountingCodes>> {
        return this.Post<TAgencyAccounting.GetAccountingCodes>({
            model: input,
            endPointId: 'get-accounting-codes'
        });
    }

    public UploadNote(input: TAccounting.UploadNoteInputModel): Observable<MoghimApiProxyResult<TAccounting.UploadNote>> {
        return this.PostForSingle<TAccounting.UploadNote>({
            model: input,
            endPointId: 'upload-note'
        });
    }

    public ManageAccountingCode(input: TAccounting.ManageAccountingCodeInputModel): Observable<MoghimApiProxyResult<any>> {
        return this.PostForSingle<any>({
            model: input,
            endPointId: 'manage-accounting-code'
        });
    }

    public DeleteNote(input: TAccounting.DeleteNoteInputModel): Observable<MoghimApiProxyResult<TAccounting.DeleteNote>> {
        return this.PostForSingle<TAccounting.DeleteNote>({
            model: input,
            endPointId: 'delete-note'
        });
    }

    public GetNotes(): Observable<MoghimApiProxyResult<TAccounting.GetNotes>> {
        return this.PostForSingle<TAccounting.GetNotes>({
            endPointId: 'get-notes'
        });
    }

    public GetOneNote(input: TAccounting.GetOneNotesInputModel): Observable<MoghimApiProxyResult<TAccounting.UploadNote>> {
        return this.PostForSingle<TAccounting.UploadNote>({
            model: input,
            endPointId: 'get-one-notes'
        });
    }

    public DeleteArticle(input: TAccounting.DeleteArticleInputModel): Observable<MoghimApiProxyResult<TAccounting.DeleteArticle>> {
        return this.PostForSingle<TAccounting.DeleteArticle>({
            model: input,
            endPointId: 'delete-article'
        });
    }

    public DeleteArticleWithoutSubCode(input: TAccounting.DeleteArticleWithoutSubCodeInputModel): Observable<MoghimApiProxyResult<any>> {
        return this.PostForSingle<any>({
            model: input,
            endPointId: 'delete-article-Without-Sub-Code'
        });
    }

    public RegisterNote(input: TAccounting.RegisterNoteInputModel): Observable<MoghimApiProxyResult<any>> {
        return this.PostForSingle<any>({
            model: input,
            endPointId: 'register-note'
        });
    }

    public GetRemainedCredit(): Observable<MoghimApiProxyResult<TAccounting.GetRemainedCredit>> {
        return this.Post<TAccounting.GetRemainedCredit>({
            endPointId : 'get-remained-credit'
        });
    }

    public RegistrationInfo(input: TAccounting.RegistrationInfoInputModel): Observable<MoghimApiProxyResult<TAccounting.RegistrationInfo>> {
        return this.PostForSingle<TAccounting.RegistrationInfo>({
            model: input,
            endPointId: 'registration-info'
        });
    }
    
}
